import React, { useContext } from "react";
import renderHTML from "react-render-html";
import withStyles from "@material-ui/core/styles/withStyles";
import CallToAction from "../proposal/partials/cta";
import ApplicationContext from "../../context/index";
import { useParams } from "react-router";
import { Box, Typography } from "@material-ui/core";
import { useStyles } from "./styles";
import { Images } from "../../constants/images";
import {
  BUTTON_DASHBOARD,
  FORMAT_DD_MM_YYYY,
  RUPEE_SYMBOL,
  SLUG_SKIP_COPAYMENT,
} from "../../constants";
import { convertDateTimeFormat } from "../../helpers/date";

function AcknowledgeForm(props) {
  const {
    classes: { center, container, main },
    clickHandler,
  } = props;
  const {
    state: {
      orderDetails: {
        userDetails: { copayment_amount = 0, razorpay_order_id = "" },
        serviceCentre: { name, address, city, state, pincode, mobile, email },
        claimDetailsData: {
          inputs: { preferred_date, preferred_timeslot },
        },
      },
    },
    dispatch,
  } = useContext(ApplicationContext);
  const { claim } = useParams();

  return (
    <Box className={main}>
      <Box className={center}>
        <Box className={container}>
          <Box mb={5}>
            <Box m={1}>
              <img src={Images.policyIssued} alt="" />
            </Box>
            <Box m={1}>
              {(copayment_amount > 0 && razorpay_order_id !== SLUG_SKIP_COPAYMENT) && (
                <Typography variant={"h5"} gutterBottom>
                  Thank you for your claim co-payment of
                  <span> {`${RUPEE_SYMBOL}${Number(copayment_amount).toLocaleString(
                      "en"
                    )}`}</span>
                   
                </Typography>
              )}

              <Typography variant={"body2"} gutterBottom>
                Your claim has been initiated successfully. Your service request number is <b>{`${claim}`}</b>
              </Typography>
            </Box>
            <Box m={1}>
              <Typography variant={"body2"} gutterBottom>
                {renderHTML(
                  `Please submit your phone to the service centre by [+15 days]. Otherwise, your claim will get cancelled.`
                )}
              </Typography>
            </Box>

            {/* <Box m={2}>
              Placeholder for Address Google Map
            </Box> */}

            <Box>
              <CallToAction
                handleClick={clickHandler}
                text={BUTTON_DASHBOARD}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(AcknowledgeForm);
